module.exports = __webpack_public_path__ + "img/discount-icon.764170a0.svg";